import { ArrowDown } from "lucide-react";

const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/57407f6c-76a2-4eb0-9f90-849104b8ea6c/images/b5ae1db51302788692ed3cd42391fd6d196a96000ab190cf19073c6da1b129af.png"
          alt="The Lemonade Living Company – burnout recovery and mental wellbeing resources for women professionals in South Africa"
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(to bottom, rgba(250,249,245,0.5), rgba(250,249,245,0.85))" }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center py-24 md:py-32">
        <p
          className="text-xs tracking-[0.3em] uppercase mb-6 animate-fade-in-up opacity-0"
          style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
        >
          Mental Wellbeing & Wellness
        </p>

        <h1
          className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light leading-[1.1] mb-8 animate-fade-in-up opacity-0 animate-delay-100"
          style={{ color: "var(--ll-text)" }}
        >
          From Burnout{" "}
          <em className="italic font-light" style={{ color: "var(--ll-text-secondary)" }}>
            to Balance
          </em>
        </h1>

        <p
          className="text-base sm:text-lg max-w-xl mx-auto mb-12 leading-relaxed animate-fade-in-up opacity-0 animate-delay-200"
          style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
        >
          Evidence-informed mental wellbeing tools, courses &amp; resources
          for women professionals in South Africa. Turning life's lemons into
          growth, strength, and balance.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up opacity-0 animate-delay-300">
          <a
            href="#who-we-help"
            data-testid="hero-explore-products"
            className="rounded-full px-8 py-4 text-base font-medium transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
            style={{
              background: "var(--ll-cta)",
              color: "var(--ll-cta-text)",
              fontFamily: "'Outfit', sans-serif",
              boxShadow: "0 4px 20px rgba(42, 54, 35, 0.15)",
            }}
          >
            Start Your Journey
          </a>
          <a
            href="/shop"
            data-testid="hero-learn-more"
            className="rounded-full px-8 py-4 text-base font-medium border transition-all duration-500 hover:-translate-y-1"
            style={{
              borderColor: "var(--ll-border)",
              color: "var(--ll-text-secondary)",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            Browse Products
          </a>
        </div>

        <div className="mt-20 animate-fade-in opacity-0 animate-delay-500">
          <a href="#who-we-help" className="inline-block animate-bounce">
            <ArrowDown size={20} style={{ color: "var(--ll-text-muted)" }} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
